import { styled } from '@mui/material/styles';

export const DisplayContent = styled('div')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.body1.fontSize,
  lineHeight: theme.typography.body1.lineHeight,
  color: theme.palette.text.primary,
  padding: theme.spacing(2),

  // Reset margins for common elements
  '& p, & h1, & h2, & h3, & h4, & h5, & h6': {
    margin: 0,
    '&:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },

  '& h1': {
    fontWeight: 'bold',
    fontSize: '2em',
  },

  '& h2': {
    fontWeight: 'bold',
    fontSize: '1.5em',
  },

  '& h3': {
    fontWeight: 'bold',
    fontSize: '1.17em',
  },

  '& h4': {
    fontWeight: 'bold',
    fontSize: '15px',
  },

  // Lists styling
  '& ul': {
    listStyleType: 'disc',
    paddingLeft: theme.spacing(4),
    margin: `${theme.spacing(1)} 0`,
    '& li': {
      marginBottom: theme.spacing(0.5),
    },
  },

  '& ol': {
    listStyleType: 'decimal',
    paddingLeft: theme.spacing(4),
    margin: `${theme.spacing(1)} 0`,
    '& li': {
      marginBottom: theme.spacing(0.5),
    },
  },

  // Blockquote styling
  '& blockquote': {
    borderLeft: `4px solid ${theme.palette.divider}`,
    paddingLeft: theme.spacing(2),
    margin: `${theme.spacing(2)} 0`,
    fontStyle: 'italic',
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.action.hover,
    padding: theme.spacing(1, 2),
    borderRadius: theme.shape.borderRadius,
  },

  // Links styling
  '& a': {
    color: '#0074A6',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
    '&:focus': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },

  // Table styling
  '& table': {
    width: '100%',
    borderCollapse: 'collapse',
    margin: `${theme.spacing(2)} 0`,
    border: `1px solid ${theme.palette.divider}`,

    '& th, & td': {
      padding: theme.spacing(1),
      textAlign: 'left',
      borderBottom: `1px solid ${theme.palette.divider}`,
    },

    '& th': {
      backgroundColor: theme.palette.action.hover,
      fontWeight: theme.typography.fontWeightMedium,
    },
  },

  '& .fr-strong': {
    fontWeight: 'bold',
  },

  // Image styling
  '& img': {
    maxWidth: '100%',
    height: 'auto',
    borderRadius: theme.shape.borderRadius,
  },

  // Code styling
  '& code': {
    backgroundColor: theme.palette.action.hover,
    padding: theme.spacing(0.25, 0.5),
    borderRadius: (theme.shape.borderRadius as number) / 2,
    fontFamily: 'monospace',
    fontSize: '0.875em',
  },

  '& pre': {
    backgroundColor: theme.palette.action.hover,
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    overflow: 'auto',

    '& code': {
      backgroundColor: 'transparent',
      padding: 0,
    },
  },

  // Horizontal rule
  '& hr': {
    border: 'none',
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: `${theme.spacing(3)} 0`,
  },

  // Strong and emphasis
  '& strong, & b': {
    fontWeight: theme.typography.fontWeightBold,
  },

  '& em, & i': {
    fontStyle: 'italic',
  },

  // Strikethrough
  '& s, & strike, & del': {
    textDecoration: 'line-through',
  },

  // Underline
  '& u': {
    textDecoration: 'underline',
  },

  // Subscript and superscript
  '& sub, & sup': {
    fontSize: '0.75em',
    lineHeight: 0,
    position: 'relative',
    verticalAlign: 'baseline',
  },

  '& sup': {
    top: '-0.5em',
  },

  '& sub': {
    bottom: '-0.25em',
  },
}));
